import InfoModal from './info-modal';
export default InfoModal;